import React, {lazy} from "react";
import CenteredLoadingScreen from "components/CenteredLoadingScreen";
import PrivateRoute from "components/PrivateRoute";
const CheckPointMainPage = lazy(() => import('pages/app/checkpoint'))

const checkpointRoutes = [
    <PrivateRoute exact path="/app/checkpoint" render={() => <React.Suspense fallback={<CenteredLoadingScreen />}>
        <CheckPointMainPage />
    </React.Suspense>} />,
    <PrivateRoute exact path="/app/checkpoint/location/:locationId" render={() => <React.Suspense fallback={<CenteredLoadingScreen />}>
        <CheckPointMainPage />
    </React.Suspense>} />
]

export default checkpointRoutes;